// Placeholder limits for keyword watchlists. Tune once backend limits are set.
export const MAX_KEYWORDS_COUNT = 100;
export const MAX_KEYWORDS_TOTAL_CHARS = 2000;

export interface KeywordsSizeValidation {
  ok: boolean;
  count: number;
  totalChars: number;
  countExceeded: boolean;
  charsExceeded: boolean;
  error?: string;
}

export const getKeywordsSize = (keywords: string[]): { count: number; totalChars: number } => {
  const count = keywords.length;
  const totalChars = keywords.reduce((sum, k) => sum + k.length, 0);
  return { count, totalChars };
};

export const validateKeywordsSize = (
  keywords: string[],
  limits: { maxCount?: number; maxChars?: number } = {}
): KeywordsSizeValidation => {
  const maxCount = limits.maxCount ?? MAX_KEYWORDS_COUNT;
  const maxChars = limits.maxChars ?? MAX_KEYWORDS_TOTAL_CHARS;
  const { count, totalChars } = getKeywordsSize(keywords);

  const countExceeded = count > maxCount;
  const charsExceeded = totalChars > maxChars;

  const errors: string[] = [];
  if (countExceeded) errors.push(`${count}/${maxCount} keywords`);
  if (charsExceeded) errors.push(`${totalChars}/${maxChars} characters`);

  return {
    ok: !countExceeded && !charsExceeded,
    count,
    totalChars,
    countExceeded,
    charsExceeded,
    error: errors.length > 0 ? `Keyword limit exceeded: ${errors.join(", ")}.` : undefined,
  };
};
